var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBagCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.88 7.638v-.76c0-1.37-.58-2.69-1.6-3.61a4.847 4.847 0 0 0-3.76-1.25c-2.39.23-4.4 2.54-4.4 5.04v.58c-1.4.15-2.41.58-3.08 1.32-.97 1.08-.94 2.52-.83 3.52l.7 5.57c.21 1.95 1 3.95 5.3 3.95h5.58c4.3 0 5.09-2 5.3-3.94l.7-5.59c.11-.99.14-2.43-.83-3.51-.67-.74-1.68-1.17-3.08-1.32zm-2.53-3.34c.73.66 1.14 1.6 1.14 2.58v.7H8.51v-.52c0-1.78 1.47-3.49 3.15-3.65 1-.09 1.95.22 2.69.89zm-6.14 10.49c0-2.09 1.7-3.79 3.79-3.79s3.79 1.7 3.79 3.79-1.7 3.79-3.79 3.79-3.79-1.7-3.79-3.79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.07 14.78.5-.5c.29-.29.29-.77 0-1.06a.754.754 0 0 0-1.06 0l-.5.5-.53-.53a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06l.53.53-.55.55c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22l.55-.55.53.53c.15.15.34.22.53.22s.38-.07.53-.22c.29-.29.29-.76 0-1.06l-.53-.53z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBagCross);
export default __webpack_public_path__ + "static/media/vuesax-bold-bag-cross.7196ea50cd0abca6ea0e9e7c61c48f5c.svg";
export { ForwardRef as ReactComponent };